import { useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { realLocaleSelector } from '@/domain/env/envSelector';
import logoFR from '@/components/mui/LocaleSelect/images/FR.svg';
import logoGB from '@/components/mui/LocaleSelect/images/GB.svg';
import logoIL from '@/components/mui/LocaleSelect/images/IL.svg';
import logoIT from '@/components/mui/LocaleSelect/images/IT.svg';
import logoSP from '@/components/mui/LocaleSelect/images/SP.svg';
import logoUS from '@/components/mui/LocaleSelect/images/US.svg';
import { locationChangeAction } from '@/domain/env';

// can be added white labels for example

const localeOptions = [
  {
    value: 'en',
    label: 'US',
    icon: logoUS,
    excludedFor: [],
  },
  {
    value: 'uk',
    label: 'UK',
    icon: logoGB,
    excludedFor: [],
  },
  {
    value: 'he',
    label: 'עב',
    icon: logoIL,
    excludedFor: [],
  },
  {
    value: 'es',
    label: 'ES',
    icon: logoSP,
    excludedFor: [],
  },
  {
    value: 'it',
    label: 'IT',
    icon: logoIT,
    excludedFor: [],
  },
  {
    value: 'fr',
    label: 'FR',
    icon: logoFR,
    excludedFor: [],
  },
];

function sortOptions(options, locale) {
  const [primaryValue, otherValues] = options.reduce(
    ([primaryLangOption, rest], option) =>
      !primaryLangOption && option.value === locale ? [option, rest] : [primaryLangOption, [...rest, option]],
    [null, []],
  );
  return [primaryValue, ...otherValues];
}

const useLocaleSelect = () => {
  const dispatch = useDispatch();
  const currentLocaleValue = useSelector(realLocaleSelector);
  const { labelOptions } = useTheme();
  const options = sortOptions(localeOptions, labelOptions.primaryLocale);
  const currentLocale = options.find((option) => option.value === currentLocaleValue);

  const onChangeLocale = (value) => dispatch(locationChangeAction(value));

  return { options, currentLocale, onChangeLocale };
};

export default useLocaleSelect;
